import {DomainAncestor, entityConfig, fieldInfo} from "core/common/domain/DomainAncestor";
import {observable, ObservableMap} from "mobx";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import MdField, {DATATYPE, FIELDTYPE} from "core/metamodel/mdField";
import {PRIMITIVE} from "core/metamodel/metaConstant";
import {DMLOPERATION} from "core/event/eventDomain";
import {formatId, parseId} from "core/common/utils/utils";
import mdEntityService from "./mdEntityService";


@entityConfig()
export class FieldDefaultTable extends DomainAncestor {

  @observable entityName: string;
  @observable fieldName: string;
  @observable index: number;
  @observable configLevel: LovItem;
  @observable tenantGroup: LovItem;
  @observable tenant: LovItem;
  @observable user: LovItem;
  @observable value: string;
  @observable language: LovItem;

  constructor(json: any) {
    super(json);
  }
}


@entityConfig()
export class FieldValidationTable extends DomainAncestor {

  @observable entityName: string;
  @observable fieldName: string;
  @observable index: number;
  @observable configLevel: LovItem;
  @observable tenantGroup: LovItem;
  @observable tenant: LovItem;
  @observable user: LovItem;
  @observable validation: string;
  @observable language: LovItem;
  @observable parameters: ObservableMap<string>;
  @observable qualifyExpr: string;
  @observable serverSide: boolean;

  constructor(json: any) {
    super(json);
  }

  public fromJson(json: any): this {
    super.fromJson(json, "parameters");
    if (!this.parameters) this.parameters = new ObservableMap<string>();
    return this;
  }


}

@entityConfig()
export class EntityValidationTable extends DomainAncestor {

  @observable entityName: string;
  @observable index: number;
  @observable configLevel: LovItem;
  @observable tenantGroup: LovItem;
  @observable tenant: LovItem;
  @observable user: LovItem;
  @observable validation: string;
  @observable language: LovItem;


  constructor(json: any) {
    super(json);
  }

}


export class LocaleLabel extends DomainAncestor {
  @observable locale: string;
  constructor(json: any) {
    super(json);
  }
}


// private String entityName;
//
// @Id
// @NotNull
// @Size(max = 100)
// @Column(length = 100, nullable = false)
// private String fieldName;
//
// @NotNull
// @Size(max = 100)
// @Column(length = 100, nullable = false)
// private String defaultLabel;
//
// @NotNull
// @Enumerated(EnumType.STRING)
// @Column(length = 30, nullable = false)
// private CLIENTDATATYPE dataType;

@entityConfig()
export class DynamicFieldConfig extends DomainAncestor {
  @observable entityName: string;
  @observable fieldName: string;
  @observable defaultLabel: string;
  @observable dataType: LovItem<DATATYPE>;
  @observable tenantGroups?: number[];
  @observable tenants?: number[];

  constructor(json: any) {
    super(json);
    if (!this.tenantGroups) this.tenantGroups = [];
    if (!this.tenants) this.tenants = [];
  }

}


@entityConfig()
export class MdFieldDto extends DomainAncestor {

  @observable entityName: string;
  @observable fieldName: string;
  @observable fieldType: FIELDTYPE;
  @observable @fieldInfo(DynamicFieldConfig) dynamicFieldConfig: DynamicFieldConfig;

  @observable @fieldInfo(FieldDefaultTable) defaults: FieldDefaultTable[];
  @observable @fieldInfo(FieldValidationTable) validations: FieldValidationTable[];
  @observable @fieldInfo(LocaleLabel) locales?: ObservableMap<LocaleLabel[]>;




  constructor(json: any) {
    super(json);
    if (!this.locales) this.locales = new ObservableMap<LocaleLabel[]>();
    if (!this.defaults) this.defaults = [];
    if (!this.validations) this.validations = [];

  }

  public fromJson(json: any): this {
    super.fromJson(json, "locales");
    return this;
  }

  public getId(): string {
    return formatId(this.entityName, this.fieldName);
  }
}


@entityConfig()
export class MdEntityDto extends DomainAncestor {
  mdEntity: string;

  @observable @fieldInfo(EntityValidationTable) validations: EntityValidationTable[];

  $entityRef: MdEntity;

  constructor(json: any) {
    super(json);
  }
}


export interface MdHibernateEvent {
  entityName: string;
  id: number;
  entityId: PRIMITIVE;
  operation: DMLOPERATION;
}

@entityConfig()
export class DynamicField extends DomainAncestor {

  @observable value: any;
  @observable dynamicFieldConfig: string;
  @observable fieldName: string;
  $mdFieldRef: MdField;

  constructor(json: any) {
    super(json);
  }

  fromJson(json: any, ...mapFields): this {
    super.fromJson(json, ...mapFields);

    const [entityName, fieldName] = parseId(this.dynamicFieldConfig);
    this.fieldName = fieldName;
    let fieldEntity = mdEntityService.getEntity(entityName);
    this.$mdFieldRef = fieldEntity.getField(fieldName);

    return this;
  }


}




export function initDynamicFields(entityName: string, dataObject: DomainAncestor & {fields: DynamicField[]}) {
  let dynFields =  dataObject.fields.reduce((acc, dynField) => {
    acc[dynField.fieldName] = dynField;
    return acc;
  }, {});
  let invoiceEntity = mdEntityService.getEntity(entityName);
  if (invoiceEntity) {
    invoiceEntity.getDynamicFields().forEach(mdField => {
      if (!dynFields[mdField.fieldName]) {
        dataObject.fields.push(new DynamicField({dynamicFieldConfig: mdField.fieldKey, label: mdField.label}))
      }
    });
  }
  dataObject.fields = dataObject.fields.sort((a,b) => a.label.localeCompare(b.label));
}



// WEBPACK FOOTER //
// ./src/core/metamodel/metaDomain.ts